var map = {
	"./4 sensors.png": [
		1090,
		90
	],
	"./Ela coin holder sticker.png": [
		2377,
		377
	],
	"./GOGET-product.png": [
		335
	],
	"./Goget Device Lume.png": [
		1364,
		364
	],
	"./Goget Device back.png": [
		8298,
		298
	],
	"./Goget Device back2.png": [
		5170,
		170
	],
	"./Goget Device complete.png": [
		1238,
		238
	],
	"./Goget Device front.png": [
		4305,
		686
	],
	"./Goget Device side.png": [
		3514,
		514
	],
	"./Goget Device side2.png": [
		5970,
		970
	],
	"./MobileApp.png": [
		7448
	],
	"./MyReservation.png": [
		2487
	],
	"./RDX-lume.png": [
		619
	],
	"./RDX-signature.png": [
		52
	],
	"./RDX_Lume theme.png": [
		9798,
		798
	],
	"./RoomDevice-3D.png": [
		4730
	],
	"./RoomDevice-Sensor-3D.png": [
		4645
	],
	"./Wayfinder-3D.png": [
		4684
	],
	"./american-express.png": [
		5642,
		642
	],
	"./appstore-QR.png": [
		823
	],
	"./appstore.png": [
		1127
	],
	"./authentication-layout-bg.png": [
		3590,
		590
	],
	"./btn_google_signin_dark_disabled_web.png": [
		3157,
		157
	],
	"./btn_google_signin_dark_focus_web.png": [
		5555,
		555
	],
	"./btn_google_signin_dark_normal_web.png": [
		708,
		708
	],
	"./btn_google_signin_dark_pressed_web.png": [
		4813,
		813
	],
	"./default-avatar.png": [
		4648
	],
	"./deskIcon.png": [
		3551,
		551
	],
	"./features-group.png": [
		5456,
		456
	],
	"./floor-map-2 1.png": [
		3568
	],
	"./floor-plan.png": [
		1065
	],
	"./floormap-2D.png": [
		9928,
		928
	],
	"./floormap-3D.png": [
		4275,
		275
	],
	"./gogetDevice.png": [
		9671
	],
	"./google-play.png": [
		1019
	],
	"./googleplay-QR.png": [
		9802
	],
	"./iPhone-13.png": [
		2271
	],
	"./logo.png": [
		2806
	],
	"./mastercard.png": [
		3983,
		983
	],
	"./pairing-screen.png": [
		7926,
		926
	],
	"./qr-code-scan.png": [
		5034
	],
	"./sensor schema.png": [
		8828,
		828
	],
	"./sensor_beam.png": [
		4303,
		303
	],
	"./sensor_holder_pir.png": [
		1912,
		912
	],
	"./visa.png": [
		2244,
		244
	],
	"./wayfinder_paringCode_ex.png": [
		2091,
		91
	],
	"./wfx-wall-device.png": [
		9434
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7288;
module.exports = webpackAsyncContext;